define(
    'viewmodels/suspended',[
        "viewmodels/ViewModel",
        "i19n!i19n/strings",
        "providers/dataprovider",
        "plugins/router"
    ],
    function (ViewModel, i19n, dataProvider, router) {
        var isTest = false;
        var wndInterval = null;

        var vm = new ViewModel({
            i19n: i19n,
            isCardAdded: ko.observable(false),
            isCustomerTrial: ko.observable(false),
            isInstanceAdmin: ko.observable(false)            
        });

        vm.activate = function () {
            try { isTest = sessionStorage.getItem("__istest") == "1"; } catch (ex) { isTest = false; }
            
            vm.isInstanceAdmin(vm.session.role == 4 ? true : false);

            return dataProvider.subscription
            .getCustomerSubs()
            .done(function (subs) {
                vm.isCustomerTrial(subs.subsMaxUserCount == 999);
                vm.isCardAdded(subs.isCardAdded);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                console.error(e);
            });
        };
        vm.attached = function () {
            if ($('a#___subscriptionlink').length == 0) {
                var link = document.createElement('a');

                link.setAttribute('target', '_blank');
                link.setAttribute('id', '___subscriptionlink');

                document.body.appendChild(link);
            }
        };

        vm.enterPayment = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                window.open(window.location.origin + window.location.pathname + "#plan/0", "_blank");

                wndInterval = setInterval(function () {
                    dataProvider.subscription
                    .getCustomerSubs()
                    .done(function (subs) {
                        vm.isCardAdded(subs.isCardAdded);

                        if (subs.isCardAdded) {
                            if (wndInterval) {
                                clearInterval(wndInterval);
                            }

                            wndInterval = null;

                            complete();
                        }
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;

                        console.error(e);
                    });
                }, 1000);
            }
        });
        vm.manageAccount = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                //also in people, explorer, account, settings
                dataProvider.subscription
                .getOrCreateSessionPortal({ redirectUrl: 'www.fileplanapp.com', instanceId: window.fileplan.instanceCode })
                .done(function (data) {
                    $('a#___subscriptionlink')[0].setAttribute('href', data.accessUrl);
                    $('a#___subscriptionlink')[0].click();
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    vm.notify(e.error);

                    console.warn(e);

                    complete();
                })
                .always(function () {
                    wndInterval = setInterval(function () {
                        dataProvider.subscription
                        .getCustomerSubs()
                        .done(function (subs) {
                            vm.isCardAdded(subs.isCardAdded);

                            if (subs.isCardAdded) {
                                if (wndInterval) {
                                    clearInterval(wndInterval);
                                }

                                wndInterval = null;

                                complete();
                            }
                        })
                        .fail(function (e) {
                            e.stopPropagation = true;

                            console.error(e);
                        });
                    }, 1000);                    
                });
            }
        });
        vm.reactivateSubscription = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isCardAdded();
            },
            execute: function (complete) {
                dataProvider.subscription
                .reactivateSubscription()
                .done(function (data) {
                    router.navigate('#login');

                    window.location.hash = "#login";
                    window.location.reload(true);
                })
                .fail(function (e) {
                    console.error(e);
                })
                .always(function () {
                    complete();
                });
            }
        });

        return vm;

    }
);
